export const ArbeitAmFeiertagTyp = {
    ohneBeruecksichtigung: '',
    Gutzeit: 'Gutzeit',
    Abgeltung: 'Abgeltung'
};
